<div class="row pt-5 px-2 pb-6">
  <div class="header-container col-sm">
    <ng-container *ngIf="isAutoGeneratedShowcase; else entityTitle">
      <ng-container [ngSwitch]="showcaseType">
        <h3 class="title" translate *ngSwitchCase="showcasesTypes.SHELF">shelfSeeAllTitle</h3>
        <ng-container *ngSwitchCase="showcasesTypes.GENRE">
          <span class="icon-genres"></span>
          <h3 class="title" translate [translateParams]="{ value: identifier }">genreSeeAllTitle</h3>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #entityTitle>
      <ng-container *ngIf="showcaseType !== showcasesTypes.CUSTOM; else customShowcaseTitle">
        <ng-container
          *ngIf="((entity.entityType === INSTANCE || entity.entityType === FORMAT_GROUP) &&
          showcaseType !== showcasesTypes.NYT && showcaseType !== showcasesTypes.RESOURCES) ||
          (entity.entityType !== INSTANCE && entity.entityType !== FORMAT_GROUP)">
          <span class="icon-related-resources"></span>
          <h3 class="title" data-automation-id="showcase-title" translate>resourcesShowcaseTitle</h3>
        </ng-container>
        <ng-container
          *ngIf="(entity.entityType === INSTANCE || entity.entityType === FORMAT_GROUP) && showcaseType === showcasesTypes.RESOURCES">
          <span class="icon-related-resources"></span>
          <h3 class="title" data-automation-id="showcase-title" translate>relatedResourcesShowcaseTitle</h3>
        </ng-container>
      </ng-container>
      <ng-template #customShowcaseTitle>
        <app-showcase-header [icon]="customShowcaseIcon" [creator]="metadata.creator">
          {{metadata.name}}
        </app-showcase-header>
      </ng-template>
    </ng-template>
  </div>

  <app-see-all-button
    class="col-auto"
    *ngIf="isSeeAllButtonVisible"
    seeAllType="see-all-resources"
    [url]="showcaseType === showcasesTypes.CUSTOM ? ['/library-list', 'showcase', identifier] : ['/search', 'card']"
    [queryParams]="showcaseType !== showcasesTypes.CUSTOM ? {
      id: entity.id,
      entityType: entity.entityType,
      showcase: showcaseType,
      identifier: identifier || null,
      showcaseId: showcaseId || null
    } : null">
    <ng-container
      *ngIf="(entity.entityType === INSTANCE || entity.entityType === FORMAT_GROUP) && showcaseType === showcasesTypes.RESOURCES">
      {{ 'seeAll' | translate }} {{ totalCount }} {{ 'resourcesTitleRelatedResources' | translate }}
    </ng-container>
    <ng-container
      *ngIf="((entity.entityType === INSTANCE || entity.entityType === FORMAT_GROUP) &&
      showcaseType !== showcasesTypes.NYT && showcaseType !== showcasesTypes.RESOURCES) ||
      (entity.entityType !== INSTANCE && entity.entityType !== FORMAT_GROUP)">
      {{ 'seeAll' | translate }} {{ totalCount }} {{ 'resourcesTitleResources' | translate }}
    </ng-container>
  </app-see-all-button>

</div>
<div class="row content px-5 px-sm-21">
  <ng-container *ngIf="!isLoading; else loading">
    <ul class="d-flex flex-column flex-sm-row flex-wrap list-unstyled mb-0">
      <li class="item mb-8 mb-sm-13" *ngFor="let resource of resources; let i = index">
        <app-single-showcase-resource
          *ngIf="i + 1 !== resourcePerPage || !isSeeAllButtonVisible"
          [resource]="resource"
          [index]="i"
          [entityId]="entity.id"
          [showcaseType]="showcaseType">
        </app-single-showcase-resource>
        <a class="resource-more"
           data-automation-id="resource-more-link"
           *ngIf="isSeeAllButtonVisible && i + 1 === resourcePerPage"
           [routerLink]="showcaseType === showcasesTypes.CUSTOM ? ['/library-list', 'showcase', identifier] : ['/search', 'card']"
           [queryParams]="showcaseType !== showcasesTypes.CUSTOM ? {
                    id: entity.id,
                    entityType: entity.entityType,
                    showcase: showcaseType,
                    identifier: identifier || null,
                    showcaseId: showcaseId || null
                  } : null">
          <div class="resource-more-bg d-flex justify-content-center align-items-center h-100">
            <span
              class="cdk-visually-hidden"
              data-automation-id="resource-more-hint"
              translate
              [translateParams]="{ value: showMoreResourcesCount }">
              showMoreResourcesCount
            </span>
            <span translate [translateParams]="{ value: showMoreResourcesCount }" class="resources-more-text" data-automation-id="resource-more-text" [attr.aria-hidden]="true">
              showMoreResourcesCount
            </span>
          </div>
        </a>
      </li>
    </ul>
  </ng-container>
</div>

<ng-template #loading>
  <div class="loading-spinner">
    <div class="spinner-border text-primary loader-spinner" role="status" aria-live="polite">
      <span class="sr-only" translate>
        Loading...
      </span>
    </div>
  </div>
</ng-template>
